import { render, staticRenderFns } from "./Badge13.vue?vue&type=template&id=6e4fc2c2&scoped=true"
import script from "./Badge13.vue?vue&type=script&lang=js"
export * from "./Badge13.vue?vue&type=script&lang=js"
import style0 from "./Badge13.vue?vue&type=style&index=0&id=6e4fc2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4fc2c2",
  null
  
)

export default component.exports